import { todayString } from "./todaysPlanService";

export function fetchTodaysPlanSettings(url) {
  return new Promise((resolve, reject) => {
    $.ajax({ url })
      .done((data) => resolve((data && data.config) || null))
      .fail(reject);
  });
}

export function saveTodaysPlanSettings(url, config) {
  return new Promise((resolve, reject) => {
    $.ajax({ contentType: "application/json", data: JSON.stringify({ config }), method: "put", url })
      .done(resolve)
      .fail(reject);
  });
}

export function localKey(name, username, languagePairingId) {
  const key = `${username || ""}:todaysPlan${name}`;
  return languagePairingId === undefined ? key : `${key}:${languagePairingId}`;
}

export function readLocal(key) {
  try {
    const raw = window.localStorage.getItem(key);
    return raw === null ? null : JSON.parse(raw);
  } catch(e) {
    return null;
  }
}

export function writeLocal(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch(e) {
    // Storage full or blocked: what it remembers is only a convenience.
  }
}

export function readLegacyPlan(username) {
  const readLegacy = (name) => readLocal(`${username}:dashboardTodaysPlan${name}`);
  const asList = (value) => Array.isArray(value) ? value : [];
  const asMap = (value) => value && typeof value === "object" && !Array.isArray(value) ? value : {};
  const options = asMap(readLegacy("Options"));
  return {
    newWordsOrder: asList(readLegacy("NewOrder")),
    options: Object.fromEntries(Object.entries(options).filter(([, section]) => Object.keys(asMap(section)).length)),
    reviewOrder: asList(readLegacy("ReviewOrder")),
    unchecked: asMap(readLegacy("Unchecked"))
  };
}

export function readTodaysExtraNewWords(username, languagePairingId) {
  const saved = readLocal(localKey("ExtraNewWords", username, languagePairingId));
  return saved && saved.date === todayString() ? saved : { count: 0, extra: 0 };
}
